"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.conditionalClass = void 0;
const lodash_1 = __importDefault(require("lodash"));
const conditionalClass = (...classes) => {
    let classes_formatted = [];
    for (const item of classes) {
        if (item === null || item === undefined) {
            continue;
        }
        if (typeof item === 'string') {
            classes_formatted.push(item);
            continue;
        }
        if (Array.isArray(item)) {
            const arrayItems = item.filter((value) => lodash_1.default.toString(value));
            classes_formatted = [...classes_formatted, ...arrayItems];
            continue;
        }
        for (const itemKey in item) {
            if (item[itemKey]) {
                classes_formatted.push(itemKey);
            }
        }
    }
    return classes_formatted.join(' ');
};
exports.conditionalClass = conditionalClass;
